/* eslint-disable no-console */
import { DEBUG } from '@/constants';
import { noop } from 'lodash';

export default Object.freeze({
    log: DEBUG ? console.log.bind(console) : noop,
    warn: DEBUG ? console.warn.bind(console) : noop,
    error: DEBUG ? console.error.bind(console) : noop,
    group: DEBUG ? console.group.bind(console) : noop,
    groupCollapsed: DEBUG ? console.groupCollapsed.bind(console) : noop,
    groupEnd: DEBUG ? console.groupEnd.bind(console) : noop,
});